<ng-container *transloco="let t">
  @if (product && (popularDevices$ | async) && oftenTogether) {
    <section
      class="bought-together-banner text-black"
      [class.widescreen]="(biggerThan$ | async)?.sm"
      [class.md]="(biggerThan$ | async)?.md">
      <h1>{{ t('label_often_together') }}</h1>
      <span class="fixed-space-16"></span>
      <div class="grid popsy-card">
        <!-- PRODCUCT -->
        <div>
          <div class="image-fit-wrapper phone-img">
            <app-picture
              class="image"
              [class.rtl]="isRtlLayout$ | async"
              [alt]="product?.title"
              [pictureUrl]="(product?.images || [])[0]?.toString()"></app-picture>
          </div>
          <h4 [class.wide-title]="product?.category === 'LAPTOP'">
            {{ product?.title || product?.model || '' }}
          </h4>
          <span class="flex justify-center flex-wrap">
            <span>{{ t('label_condition') }}:</span>
            <span class="fixed-space-4"></span>
            <span>{{ t(getTransLabel(oftenTogether.condition)) }}</span>
          </span>
          @if ((biggerThan$ | async)?.sm) {
            <span class="flex flex-wrap justify-center align-base">
              @if (product?.originalPrice) {
                <span class="small crossed"> {{ product?.originalPrice | amount }} </span>
              }
              <span class="fixed-space-4"></span>
              <h4 class="text-secondary">{{ product?.price | amount }}</h4>
            </span>
          }
          <span class="fixed-space-16"></span>
        </div>
        <popsy-icon-add class="icon"></popsy-icon-add>
        <!-- OFTEN -->
        <a
          class="image-fit-wrapper often-together"
          [routerLink]="urlFragments"
          [queryParams]="queryParams$ | async"
          (click)="scrollToTop()">
          <app-picture
            class="image"
            [class.rtl]="isRtlLayout$ | async"
            [alt]="oftenTogether?.title"
            [pictureUrl]="(oftenTogether?.images || [])[0]?.toString()"></app-picture>
          <span class="dynamic-space"></span>
          <h4 [class.wide-title]="oftenTogether?.category === 'LAPTOP'">
            {{ oftenTogether?.title || oftenTogether?.model || '' }}
          </h4>
          <span class="flex justify-center flex-wrap">
            <span>{{ t('label_condition') }}:</span>
            <span class="fixed-space-4"></span>
            <span>{{ t(getTransLabel(oftenTogether.condition)) || '' }}</span>
          </span>
          @if ((biggerThan$ | async)?.sm) {
            <span class="flex flex-wrap justify-center align-base">
              @if (oftenTogether?.originalPrice) {
                <span class="small crossed">
                  {{ oftenTogether?.originalPrice | amount }}
                </span>
              }
              <span class="fixed-space-4"></span>
              <h4 class="text-secondary">{{ oftenTogether?.price | amount }}</h4>
            </span>
          }
          <span class="fixed-space-16"></span>
        </a>
        @if ((biggerThan$ | async)?.sm) {
          <div class="vertical-line"></div>
        }
        <!-- <ng-container>
        <div class="line" *ngIf="!(biggerThan$ | async)?.sm"></div>
      </ng-container> -->
        <div class="total-price">
          <span class="flex flex-col align-center justify-center">
            <strong>{{ t('label_estimated_price_total') }}:</strong>

            <div class="flex">
              <h4 class="text-secondary">{{ product?.price?.currency || '' }}</h4>
              <span class="fixed-space-4"></span>
              <h4 class="text-secondary">
                {{
                  (
                    (product?.price?.amount || 0) + (oftenTogether?.price?.amount || 0)
                  ).toLocaleString()
                }}
              </h4>
            </div>
            <span
              class="small nowrap"
              [innerHTML]="
                t('price_banner_secondary_or', {
                  var1:
                    {
                      amount:
                        (product?.price?.amount || 0) +
                        (oftenTogether?.price?.amount || 0),
                      currency: product?.price?.currency || 'SAR'
                    } | installmentAmount
                })
              "></span>
            <span class="fixed-space-8"></span>

            <!--  add to cart button -->
          </span>
          <button
            class="button popsy-button-primary buy-button highlight full-width"
            [class.rtl]="isRtlLayout$ | async"
            [disabled]="!product || !oftenTogether"
            (click)="addBothToCart()">
            {{ t('action_add_both_to_cart') }}
          </button>
        </div>
      </div>
    </section>
  }
</ng-container>
